import { Avatar, Box, Link, Stack, Typography } from '@mui/material';
import Icon from '@mdi/react';

type MenuItemContentProps = {
  name: string;
  nameVariant?: `h2` | `h3`;
  icon: string;
  active: boolean;
  disabled?: boolean;
};

type MenuItemProps = MenuItemContentProps & {
  path: string;
  onActivate?: () => void;
};

const MenuItemContent = ({ active, icon, nameVariant, name, disabled }: MenuItemContentProps) => (
  <Stack
    className="menu-item-content"
    direction="row"
    spacing={2}
    alignItems="center"
    sx={{
      '& .MuiAvatar-root': {
        backgroundColor: active ? `primary.dark` : `transparent`,
        color: disabled ? `text.disabled` : active ? `white` : `text.primary`,
      },
      '&:hover': {
        '& .MuiAvatar-root': {
          color: disabled ? `text.disabled` : active ? `text.primary` : `primary.dark`,
          backgroundColor: disabled ? `transparent` : `primary.light`,
        },
      },
      padding: 1,
    }}
  >
    <Stack sx={{ width: 48, height: 48 }} justifyContent="center" alignItems="center">
      <Avatar
        sx={(theme) => ({
          height: theme.spacing(6),
          width: theme.spacing(6),
          maxWidth: theme.spacing(6),
          '& svg': {
            color: `inherit`,
          },
          backgroundColor: theme.palette.common.white,
        })}
      >
        <Icon path={icon} size={1} />
      </Avatar>
    </Stack>
    <Typography variant={nameVariant} color="inherit">
      {name}
    </Typography>
  </Stack>
);

export const MenuItem = ({ path, onActivate, ...contentProps }: MenuItemProps) => {
  return contentProps.disabled ? (
    <Box sx={{ cursor: `default` }}>
      <MenuItemContent {...contentProps} />
    </Box>
  ) : (
    <Link href={path} onClick={onActivate} underline="none">
      <MenuItemContent {...contentProps} />
    </Link>
  );
};
